import React, { useCallback } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import DropdownMenu, { DropdownItemGroup } from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';
import { useIntl } from '@atlassian/jira-intl';
import { fireOperationalAnalytics, MountEvent } from '@atlassian/jira-product-analytics-bridge';
import messages from '../messages';
import DeleteAllItem from './delete-all-item';
import DownloadAllItem from './download-all-item';
import SwitchViewItem from './switch-view-item';
import type { Props } from './types';

const MeatBalls = ({ refreshAttachments, isPreview, defaultOpen = false }: Props) => {
	const { formatMessage } = useIntl();
	const renderDropdownMenuButton = useCallback(
		// @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
		({ triggerRef, ...triggerProps }) => (
			<Button
				{...triggerProps}
				appearance="subtle"
				spacing="compact"
				iconBefore={<MoreIcon size="small" label={formatMessage(messages.attachmentsAriaLabel)} />}
				isDisabled={isPreview}
				ref={triggerRef}
				interactionName="auto-generated.jira-issue-view-base.content.attachment.heading.meatballs.button"
			/>
		),
		[formatMessage, isPreview],
	);
	return (
		<>
			<DropdownMenu
				defaultOpen={defaultOpen}
				placement="bottom-end"
				trigger={renderDropdownMenuButton}
				/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
				testId="issue.views.issue-base.content.attachment.heading.meatballs.drop-down"
			>
				<DropdownItemGroup>
					<SwitchViewItem refreshAttachments={refreshAttachments} />
					<DownloadAllItem />
					<DeleteAllItem />
				</DropdownItemGroup>
			</DropdownMenu>
			<MountEvent
				onMount={(analyticsEvent: UIAnalyticsEvent) =>
					fireOperationalAnalytics(analyticsEvent, 'AttachmentListViewOnboarding mounted')
				}
			/>
		</>
	);
};

export default MeatBalls;
